// extracted by mini-css-extract-plugin
export var descriptions = "Merchant-module--descriptions--16f65";
export var header = "Merchant-module--header--193ed";
export var info = "Merchant-module--info--4ec43";
export var merchant = "Merchant-module--merchant--a35d1";
export var name = "Merchant-module--name--3a0ed";
export var productList = "Merchant-module--product-list--84d9e";
export var specialties = "Merchant-module--specialties--74a34";